module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/140.88f63eb2.png";